import { ReportingService } from '../services/reporting.service';
import { FileSaverService } from '../../shared/services/file-saver.service';
import { AlphabeticalNamedSorter } from '../../shared/sort-methods';
import { LoadingWrapperService } from '../../shared/services/loading-wrapper.service';
import { finalize } from 'rxjs/operators';
import { AlertService } from '../../shared/services/alert.service';
import { SamplingReportFormGroup } from './sampling-report-form-group';
var SamplingReportFormComponent = /** @class */ (function () {
    function SamplingReportFormComponent(options, loadingService, alertService, reportingService, reportWriterService) {
        var _this = this;
        this.loadingService = loadingService;
        this.alertService = alertService;
        this.reportingService = reportingService;
        this.reportWriterService = reportWriterService;
        this.rootForm = new SamplingReportFormGroup();
        options.crops.subscribe(function (c) { return _this.crops = c.sort(AlphabeticalNamedSorter); });
        options.laboratories.subscribe(function (l) { return _this.laboratories = l.sort(AlphabeticalNamedSorter); });
        options.growthStages.subscribe(function (s) { return _this.growthStages = s.sort(AlphabeticalNamedSorter); });
        this.laboratoryFormControl
            .valueChanges
            .subscribe(function (laboratoryId) { return _this.onLaboratoryChange(laboratoryId); });
    }
    Object.defineProperty(SamplingReportFormComponent.prototype, "plantingDateRangeFormControl", {
        get: function () {
            return this.rootForm.plantingDateRangeFormControl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SamplingReportFormComponent.prototype, "samplingDateRangeFormControl", {
        get: function () {
            return this.rootForm.samplingDateRangeFormControl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SamplingReportFormComponent.prototype, "cropFormControl", {
        get: function () {
            return this.rootForm.cropFormControl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SamplingReportFormComponent.prototype, "laboratoryFormControl", {
        get: function () {
            return this.rootForm.laboratoryFormControl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SamplingReportFormComponent.prototype, "laboratoryAssayFormControl", {
        get: function () {
            return this.rootForm.laboratoryAssayFormControl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SamplingReportFormComponent.prototype, "growthStageFormControl", {
        get: function () {
            return this.rootForm.growthStageFormControl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SamplingReportFormComponent.prototype, "plantingDateRange", {
        get: function () {
            return this.rootForm.plantingDateRangeFormControl && this.rootForm.plantingDateRangeFormControl.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SamplingReportFormComponent.prototype, "samplingDateRange", {
        get: function () {
            return this.rootForm.samplingDateRangeFormControl && this.rootForm.samplingDateRangeFormControl.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SamplingReportFormComponent.prototype, "plantingStartDate", {
        get: function () {
            return this.plantingDateRange && this.plantingDateRange.length > 1 && this.plantingDateRange[0];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SamplingReportFormComponent.prototype, "plantingEndDate", {
        get: function () {
            return this.plantingDateRange && this.plantingDateRange.length > 1 && this.plantingDateRange[1];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SamplingReportFormComponent.prototype, "samplingStartDate", {
        get: function () {
            return this.samplingDateRange && this.samplingDateRange.length > 1 && this.samplingDateRange[0];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SamplingReportFormComponent.prototype, "samplingEndDate", {
        get: function () {
            return this.samplingDateRange && this.samplingDateRange.length > 1 && this.samplingDateRange[1];
        },
        enumerable: true,
        configurable: true
    });
    SamplingReportFormComponent.prototype.ngOnInit = function () { };
    SamplingReportFormComponent.prototype.generateReport = function () {
        var _this = this;
        this.loadingService.setMessage('Generating sampling report...');
        this.reportingService.getSamplingReport({
            plantingStartDate: this.plantingStartDate,
            plantingEndDate: this.plantingEndDate,
            samplingStartDate: this.samplingStartDate,
            samplingEndDate: this.samplingEndDate,
            cropId: this.cropFormControl.value,
            laboratoryId: this.laboratoryFormControl.value,
            laboratoryAssayId: this.laboratoryAssayFormControl.value,
            growthStageId: this.growthStageFormControl.value
        })
            .pipe(finalize(function () { return _this.loadingService.clearMessage(); }))
            .subscribe(function (file) { return _this.reportWriterService.save(file); }, function (error) { return _this.alertService.error('Error generating sampling report.'); });
    };
    SamplingReportFormComponent.prototype.onLaboratoryChange = function (laboratoryId) {
        console.log('changed');
        this.laboratoryAssayFormControl.setValue(null);
        this.laboratoryAssays = laboratoryId === null ? [] : this.laboratories.find(function (l) { return l.id === laboratoryId; }).assays;
    };
    return SamplingReportFormComponent;
}());
export { SamplingReportFormComponent };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/reporting/sampling-report-form/sampling-report-form.component.ts.pre-build-optimizer.js